<template>
  <v-card tile class="elevation-0">
    <v-card-title>
      <slot name="title">契約情報</slot>
      <v-spacer></v-spacer>
      <v-chip
          label dark color="gray darken-4" class="ml-3 px-4"
          v-if="['common', 'consume', 'consumer'].includes(tradeContract.serviceType)">
        利用者
      </v-chip>
      <v-chip
          label dark color="gray darken-4" class="ml-3 px-4"
          v-if="['common', 'produce', 'producer'].includes(tradeContract.serviceType)">
        提供者
      </v-chip>
    </v-card-title>
    <v-card-subtitle v-if="showSubtitle">
      <slot name="subtitle"></slot>
    </v-card-subtitle>
    <v-card-text>
      <slot name="prepend"></slot>

      <v-row dense>
        <v-col cols="6" class="pr-4">
          <!-- 左半分 -->
          <v-row>
            <!-- 契約名 -->
            <v-col cols="12">
              <text-field-like
                  v-if="readonly"
                  :value="tradeContract.name"
                  :value-id="[
                      tradeContract.id,
                      tradeContract.baseId ? `${tradeContract.baseId} (募集ID)` : null
                  ]"
                  label="契約名"
                  hide-details>
              </text-field-like>
              <v-text-field
                  v-else
                  v-model="tradeContract.name"
                  label="契約名"
                  :rules="[v => !!v || '契約名が必要です']"
                  :hint="tradeContract.id"
                  persistent-hint>
              </v-text-field>
            </v-col>

            <!-- 取引先 -->
            <template v-if="companion">
              <v-col cols="6">
                <text-field-like
                    :value="companion.terminalName"
                    :value-id="companion.terminalId"
                    label="取引先サイト名"
                    hide-details>
                </text-field-like>
              </v-col>
              <v-col cols="6">
                <text-field-like
                    :value="companion.ownerName"
                    :value-id="companion.ownerId"
                    label="取引先事業者名"
                    hide-details>
                  <template #default="{value}">
                    {{ value }}
                    <icon-btn
                        type="view"
                        tooltip="事業者詳細"
                        tooltip-placement="right"
                        @click="ownerInfoDialog = companion.ownerId"
                        style="margin-top: -3px;"
                        class="ml-2"
                        x-small>
                    </icon-btn>
                  </template>
                </text-field-like>
              </v-col>
            </template>
          </v-row>
        </v-col>
        <v-col cols="6" class="pl-4" style="border-left: 1px solid #EEE;">
          <!-- 右半分 -->
          <v-row dense>
            <!-- 説明 -->
            <v-col cols="12">
              <text-field-like
                  v-if="readonly"
                  :value="tradeContract.description"
                  label="説明"
                  placeholder="未設定"
                  multi-line>
              </text-field-like>
              <v-textarea
                  v-else
                  v-model="tradeContract.description"
                  label="説明"
                  messages="複数行入力可"
                  placeholder="未入力"
                  rows="1"
                  auto-grow>
              </v-textarea>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <slot name="append"></slot>
    </v-card-text>

    <owner-info-dialog
        v-model="ownerInfoDialog">
    </owner-info-dialog>
  </v-card>
</template>

<script>
import OwnerInfoDialog from "@/components/organisms/OwnerInfoDialog.vue";
import TradeContractView from "@/components/pages/contract/TradeContract/TradeContractView";
import IconBtn from "@/components/molecules/IconBtn.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
export default {
  name: "TradeContractInfo",
  components: {TextFieldLike, IconBtn, OwnerInfoDialog},
  props: {
    tradeContract: {
      type: TradeContractView,
      required: true
    },
    companion: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  model: {
    prop: 'tradeContract',
    event: 'changeTradeContract'
  },
  data() {
    return {
      ownerInfoDialog: false
    };
  },
  computed: {
    showSubtitle() {
      return !!this.$slots['subtitle']?.length;
    }
  },
}
</script>

<style scoped>

</style>
